import type {
  PerformanceSeriesKey,
  PerformanceStatRow,
} from './agent-performance'

export const MONTHLY_TARGETS_RANGE_KEYS = {
  THIS_MONTH: 'thisMonth',
  LAST_MONTH: 'lastMonth',
  EARLIER: 'earlier',
} as const

export type MonthlyTargetsRangeKey =
  (typeof MONTHLY_TARGETS_RANGE_KEYS)[keyof typeof MONTHLY_TARGETS_RANGE_KEYS]

export const TARGET_STATUS_TONES = {
  ON_TRACK: 'onTrack',
  BEHIND: 'behind',
  AHEAD: 'ahead',
} as const

export type TargetStatusTone =
  (typeof TARGET_STATUS_TONES)[keyof typeof TARGET_STATUS_TONES]

export interface TargetStatus {
  tone: TargetStatusTone
  label: string
}

export interface TargetTrack {
  series: PerformanceSeriesKey
  target: string
  current: string
  progress: number
  paceMarker: number
  paceLabel: string
  paceAccentLabel: string
  paceAccentTone: TargetStatusTone
  daysRemainingLabel: string
  status: TargetStatus
}

export const MONTHLY_TARGETS_STAT_KEYS = {
  HIGHEST_DAY: 'highestDay',
  LOWEST_DAY: 'lowestDay',
  DAILY_AVERAGE: 'dailyAverage',
} as const

export type MonthlyTargetsStatKey =
  (typeof MONTHLY_TARGETS_STAT_KEYS)[keyof typeof MONTHLY_TARGETS_STAT_KEYS]

export interface MonthlyTargetsStat {
  key: MonthlyTargetsStatKey
  rows: ReadonlyArray<PerformanceStatRow>
}
